<div class="row mb-3">
  <div class="col-9">
    <ng-content select="[main]"></ng-content>
  </div>

  <div class="col-3 ml-auto">
    <div class="d-flex justify-content-end align-items-center " style="height: 100%;">
      <!-- <span style="margin-right: 40px;">Tổng {{total}} kết quả
      </span> -->
      <div class="filter-group" data-toggle="modal" data-target="#filterModal" *ngIf="isFilter">
        <img title="Lọc" src="/assets/images/icon/icon-filter.png" width="20" height="20">
        <span class="ml-2">Lọc thêm</span>
      </div>

      <!-- Modal Filter -->
      <div class="modal fade" id="filterModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <!-- <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Lọc tìm kiếm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div> -->
            <div class="modal-body">
              <div class="d-flex flex-column">

              </div>
              <ng-content select="[filter]"></ng-content>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="hideFilterModal" data-dismiss="modal"
                data-target="#filterModal" style="display: none;">Close</button>
              <button type="button" class="btn btn-primary w-100" (click)="search()">Tìm kiếm</button>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-group" (click)="reset()" style="cursor: pointer;">
        <img title="Đặt lại" src="/assets/images/icon/icon-reset.png" width="20" height="20">
        <span class="ml-2">Đặt lại</span>
      </div>
      <button class="btn btn--blue" *ngIf="isSearch" (click)="search()">
        <img title="Tìm kiếm" src="/assets/images/icon/icon-search.png" width="20" height="20">
      </button>

      <a class="ml-3" *ngIf="isExport" data-toggle="modal" data-target="#exportModal" style="border: none;">
        <img title="Export" src="/assets/images/icon/icon-download.png" width="36" height="36">
      </a>

      <!-- Modal Filter -->
      <div class="modal fade" id="exportModal" tabindex="-1" role="dialog" aria-labelledby="exportModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exportModalLabel">Xuất File</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-column">
                <button type="button" class="btn btn-secondary" id="hideExportModal" data-dismiss="modal"
                  data-target="#exportModal" style="display: none;">Close</button>
                <button class="btn btn-print float-right mb-3" (click)="exportFile('PDF')" *ngIf="isExportPDF">
                  {{'moneyTransaction.button.pdf' | translate}}
                  <img src="assets/images/icon/pdf.svg" width="24" alt="">
                </button>
                <button class="btn btn-print float-right" (click)="exportFile('XLS')" *ngIf="isExportXLSX">
                  {{'moneyTransaction.button.xls' | translate}}
                  <img src="assets/images/icon/excel.svg" width="24" alt="">
                </button>
                <div data-dismiss="modal">
                  <ng-content select="[export]" ></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 mt-3" *ngIf="isTotal">
    <span class="result-title">Có {{total | number}} kết quả</span>
  </div>
</div>